// extracted by mini-css-extract-plugin
export var container = "index-module--container--4FoBH";
export var gatsbyImage = "index-module--gatsbyImage--vjU61";
export var wrapper = "index-module--wrapper--G32MQ";